<template>
    <div>
        <label class="el-form--label-top" :class="{'hiddenlabel':!fieldValue}">{{ placeholderValue }} </label>
        <el-select :disabled="disabled" @change="$emit('change')" v-if="fieldType=='select'" v-model="fieldValue"
                   filterable
                   :placeholder="placeholderValue" class="w-100">
            <el-option
                v-for="(country,countryCode) in options"
                :key="'countrydrop_'+countryCode"
                :label="country"
                :value="countryCode">
            </el-option>
        </el-select>
        <el-input v-else-if="fieldType=='textarea'" :disabled="disabled" type="textarea"
                  v-model="fieldValue"></el-input>
        <el-input v-else :placeholder="placeholderValue" :disabled="disabled" v-model="fieldValue"></el-input>
        <span class="input-hint"
              v-if="['job_title','project_title','state_country_of_production','designer_name', 'architect_name','client','contractor',
              'manufacturer','photographer','other','design_team','fax'].indexOf(placeholder)>=0">
            {{ __('fieldnames.hint.' + (formName ? (formName + '.') : '') + formStep + '_' + placeholder) }}
        </span>
    </div>
</template>

<script>

export default {
    props: {
        placeholder: {type: String, default: ''},
        formName: {type: String, default: ''},
        formStep: {type: String, default: ''},
        value: {type: String | Number, default: ''},
        fieldType: {type: String, default: 'text'},
        options: {
            type: Object | Array, default: () => {
                return {}
            }
        },
        required: {type: Boolean, default: false},
        disabled: {type: Boolean, default: false}
    },
    name: 'InputWithHint',
    data: () => ({}),
    methods: {},
    computed: {
        placeholderValue: function () {
            return this.__('fieldnames.' + this.placeholder) + (this.required ? '*' : '');
        },
        fieldValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    }
}
</script>
